
let localForageService: any;
localForageService = (() => {
  return {
    // renaming tenant name in paroductGroupName param of tenant list in local forage
    renameTenant(resp : any, id : any, name : any) {
      const pgIndex = resp[0].prodGroupLicenseStatus.findIndex((ele : any) => ele.productGroupId === id);
      if (pgIndex > -1) {
        const oldName = resp[0].prodGroupLicenseStatus[pgIndex].productGroupName;
        // tslint:disable-next-line: max-line-length
        const prartyGroupNameList: any = resp[0].prodGroupLicenseStatus[pgIndex].hasOwnProperty('partyGroupName') ? resp[0].prodGroupLicenseStatus[pgIndex].partyGroupName.split(', ') : [];
        prartyGroupNameList.forEach((ele : any) => {
          const ugIndex = resp[1].userGroups.findIndex((item : any) => item.partyGroupName === ele.trim());
          const assignedPg = resp[1].userGroups[ugIndex].hasOwnProperty('productGroupName') ? resp[1].userGroups[ugIndex].productGroupName.split('^& ') : [];
          if (assignedPg.findIndex((obj : any) => obj.trim() === oldName.trim()) > -1) {
            resp[1].userGroups[ugIndex].productGroupName = resp[1].userGroups[ugIndex].productGroupName.replace(oldName.toString(), name.toString());
          }
        });
      }
      return resp;
    },
    addUserToUserGroup(resp : any, data : any, usersListResponse : any, userGroupResponse : any) {
      const ugMainIndex = resp.userGroups.findIndex((item : any) => item.partyGroupId === data.contactLists[0].partyGroupId);
      const listIndex = userGroupResponse.findIndex((item : any) => item.partyGroupId === data.contactLists[0].partyGroupId);
      data.contactLists.forEach((ele : any) => {
        const partyIndex = usersListResponse.findIndex((item : any) => item.partyId === ele.partyId);
        if (partyIndex > -1) {
          const userObj : any = {
            adminPartyId : usersListResponse[partyIndex].adminPartyId,
            contactId : usersListResponse[partyIndex].contactId,
            dtLastAccessDate: usersListResponse[partyIndex].dtLastAccessDate,
            email: usersListResponse[partyIndex].emailAddress,
            isReadOnlyAccess: usersListResponse[partyIndex].isReadOnlyAccess,
            lastAccessDate: usersListResponse[partyIndex].lastAccessDate,
            lastAccessTime: usersListResponse[partyIndex].lastAccessTime,
            login: usersListResponse[partyIndex].logon,
            name: usersListResponse[partyIndex].fullName,
            partyGroupId: ele.partyGroupId,
            partyId: usersListResponse[partyIndex].partyId,
          };
          if (ugMainIndex > -1) {
            if (resp.userGroups[ugMainIndex].hasOwnProperty('usersForUserGroup')) {
              resp.userGroups[ugMainIndex].usersForUserGroup.push(userObj);
            } else {
              resp.userGroups[ugMainIndex].usersForUserGroup = [userObj];
            }
          }
          if (listIndex > -1) {
            if (userGroupResponse[listIndex].hasOwnProperty('usersForUserGroup')) {
              userGroupResponse[listIndex].usersForUserGroup = resp.userGroups[ugMainIndex].usersForUserGroup;
            } else {
              userGroupResponse[listIndex].usersForUserGroup = resp.userGroups[ugMainIndex].usersForUserGroup;
            }
          }
        }
      });
      return {
        respOut : resp,
        userGroupResponseOut : userGroupResponse,
        index : listIndex,
      };
    },
    deleteUserFromUserGroup(usersTobeDeleted: any, resp : any) {
      const ugIndex = resp.userGroups.findIndex((ele : any) => ele.partyGroupId === usersTobeDeleted.contactLists[0].partyGroupId);
      let userIndex = -1;
      if (ugIndex > -1) {
        if (resp.userGroups[ugIndex].hasOwnProperty('usersForUserGroup')) {
          userIndex = resp.userGroups[ugIndex].usersForUserGroup.findIndex((ele : any) => ele.partyId === usersTobeDeleted.contactLists[0].partyId);
          if (userIndex > -1) {
            resp.userGroups[ugIndex].usersForUserGroup.splice(userIndex, 1);
          }
        }
      }
      return {
        respOut : resp,
        ugIndexChanged : ugIndex,
      };
    },
    saveLocalForageForNextSession(isLargeCustomer : any) {
      if (isLargeCustomer) {
        localStorage.setItem('saveLocalForageForNextSession', 'YES');
      } else {
        localStorage.setItem('saveLocalForageForNextSession', 'NO');
      }
    },
  };
})();
export default localForageService;
